import Vue from 'vue';
import EventOccurenceResourceModel from '../../generated/types/model/resource/EventOccurenceResourceModel';

export default class EventOccurenceResourceViewModel extends EventOccurenceResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
  get terminString():string {
    let output = '';
    if (this.startDate) {
      output = Vue.$format.localDateAndTime(this.startDate)!;
    }
    if (this.endDate) {
      output += ` - ${Vue.$format.localTime(this.endDate)!}`;
    }
    return output;
  }

  // 09:15 - 16:45
  get timeString():string {
    let output = '';
    if (this.startDate) {
      output = Vue.$format.localTime(this.startDate)!;
    }
    if (this.endDate) {
      output += ` - ${Vue.$format.localTime(this.endDate)!}`;
    }
    return output;
  }
}
